import {
  IconAlertTriangle,
  IconBell,
  IconBriefcase,
  IconCash,
  IconCoin,
  IconFileCertificate,
  IconFlask,
  IconGift,
  IconListDetails,
  IconLogin,
  IconLogout,
  IconMap2,
  IconMapPinHeart,
  IconPackage,
  IconPigMoney,
  IconReceipt,
  IconTruck,
  IconTruckDelivery,
  IconUsers,
  IconUserX,
} from "@tabler/icons-react";

const totalPermission = ["admin", "ceo", "user"];
const userPermission = ["user"];
const _adminPermission = ["admin"];
const _FREELANCER_PERMISSION = ["freelancer"];
const _adminPermissionon = ["partner", "admin", "freelancer"];
const ADMIN_PERMISSION = ["admin"];
const ADMIN_AND_FREELANCER = ["admin", "freelancer"];
const ADMIN = "admin";
const FREELANCER = "freelancer";
const PARTNER = "partner";

const DASHBOARD_ROUTES = [
  {
    permission: totalPermission,
    items: [
      {
        title: `배차내역`,
        url: "/history",
        permission: userPermission,
        icon: <IconTruckDelivery size={18} />,
      },
      {
        title: "거래명세서",
        url: "/invoice",
        icon: <IconReceipt size={18} />,
        permission: userPermission,
      },
      {
        title: "거래처 관리",
        url: "/partners",
        permission: userPermission,
        icon: <IconMapPinHeart size={18} />,
      },
      // {
      //   title: "단가표",
      //   url: "/pricing",
      //   permission: userPermission,
      //   icon: <IconReceipt size={18} />,
      // },
      {
        title: "상차품 관리",
        url: "/items",
        icon: <IconPackage size={18} />,
        permission: userPermission,
      },
      {
        title: "나의 마일리지",
        url: "/points",
        permission: userPermission,
        icon: <IconCoin size={18} />,
      },
      {
        title: "내 회사 관리",
        url: "/company",
        permission: userPermission,
        icon: <IconBriefcase size={18} />,
      },
      {
        title: "바른물류연구소 서식자료실",
        url: "/bctong",
        permission: userPermission,
        icon: <IconFileCertificate size={18} />,
      },
    ],
  },
  {
    title: "배차 관리",
    permission: [ADMIN, FREELANCER, PARTNER],
    items: [
      {
        title: "배차상황실",
        url: "/admin/orders",
        icon: <IconTruckDelivery size={18} />,
        permission: [ADMIN, FREELANCER, PARTNER],
      },
      {
        title: "선착불 배차상황실",
        url: "/admin/orders/fee",
        icon: <IconTruck size={18} />,
        permission: [ADMIN, FREELANCER, PARTNER],
      },
    ],
  },
  {
    title: "화주 정산 관리",
    permission: ADMIN_AND_FREELANCER,
    items: [
      {
        title: "업체별 거래내역",
        url: "/admin/bills",
        icon: <IconListDetails size={18} />,
        permission: ADMIN_AND_FREELANCER,
      },
      {
        title: "청구 내역 생성",
        url: "/admin/invoice",
        icon: <IconReceipt size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "청구 및 수금 내역",
        url: "/admin/invoicehistory",
        icon: <IconPigMoney size={18} />,
        permission: ADMIN_AND_FREELANCER,
      },
      {
        title: "미수금 관리",
        url: "/admin/invoice/unpaid",
        icon: <IconAlertTriangle size={18} />,
        permission: ADMIN_AND_FREELANCER,
      },
      {
        title: "매출 전자세금계산서",
        url: "/admin/outgoingtax",
        icon: <IconLogout size={18} />,
        permission: ADMIN_PERMISSION,
      },
    ],
  },
  {
    title: "차주 관리",
    permission: [ADMIN, PARTNER],
    items: [
      {
        title: "매입 전자세금계산서",
        url: "/admin/incomingtax",
        icon: <IconLogin size={18} />,
        permission: ADMIN_PERMISSION,
      },
      //   {
      //     title: "즉시 지급 관리",
      //     url: "/admin/accounting/quick",
      //     icon: <IconCash size={18} />,
      //     permission: ADMIN_PERMISSION,
      //   },
      {
        title: "지급 관리",
        url: "/admin/accounting",
        icon: <IconCash size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "기타 지급 관리",
        url: "/admin/tax-payments",
        icon: <IconPigMoney size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "기사 블랙리스트",
        url: "/admin/driver-blacklist",
        icon: <IconUserX size={18} />,
        permission: [ADMIN, PARTNER],
      },
    ],
  },
  {
    title: "관리자 메뉴",
    permission: ADMIN_AND_FREELANCER,
    items: [
      {
        title: "계약처 관리",
        url: "/admin/companies",
        icon: <IconBriefcase size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "상/하차지 관리",
        url: "/admin/partners",
        icon: <IconMap2 size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "상차품 관리",
        url: "/admin/items",
        icon: <IconPackage size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "평균매입가 조회",
        url: "/admin/quotations-v2",
        icon: <IconCoin size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "배차통 알림센터",
        url: "/admin/notifications",
        icon: <IconBell size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "마일리지 내역",
        url: "/admin/points",
        icon: <IconCoin size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "상품권 설정",
        url: "/admin/giftcards",
        icon: <IconGift size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "사용자 계정 관리",
        url: "/admin/users",
        icon: <IconUsers size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "바른물류연구소 서식자료실",
        url: "/bctong",
        permission: ADMIN_AND_FREELANCER,
        icon: <IconFileCertificate size={18} />,
      },
    ],
  },
  {
    title: "실험실",
    permission: [ADMIN, PARTNER],
    items: [
      // {
      //   title: "장기 미발행 계산서",
      //   url: "/admin/accounting/pending",
      //   icon: <IconCash size={18} />,
      //   permission: adminPermission,
      // },
      //   {
      //     title: "배차 추이 분석",
      //     url: "/admin/dispatch-trend",
      //     icon: <IconChartBar size={18} />,
      //     permission: ADMIN_PERMISSION,
      //   },
      {
        title: "기존 내역 분석",
        url: "/admin/price-analytics",
        icon: <IconFlask size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "거리별 운임 단가",
        url: "/admin/distance-price",
        icon: <IconFlask size={18} />,
        permission: [ADMIN, PARTNER],
      },
      {
        title: "거리 계산",
        url: "/admin/distance-calc",
        icon: <IconFlask size={18} />,
        permission: ADMIN_PERMISSION,
      },
      {
        title: "DEV",
        url: "/dev",
        icon: <IconFlask size={18} />,
        permission: ADMIN_PERMISSION,
      },
    ],
  },
];

export default DASHBOARD_ROUTES;
